import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl">
                <i className="ri-planet-line"></i>
              </span>
              <span className="font-heading text-xl font-bold text-white">在线</span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-300 max-w-xs">
              在线是一个多元化综合信息服务平台，聚合教育、娱乐、购物等在线服务信息，帮你快速查找资源、便捷使用。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">热门分类</h3>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.id}`} className="text-sm text-secondary-300 hover:text-white transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">快捷入口</h3>
            <ul className="space-y-2.5">
              <li><Link to="/categories" className="text-sm text-secondary-300 hover:text-white transition-colors">全部分类</Link></li>
              <li><Link to="/search" className="text-sm text-secondary-300 hover:text-white transition-colors">搜索资源</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-300 hover:text-white transition-colors">关于我们</Link></li>
              <li><Link to="/contact" className="text-sm text-secondary-300 hover:text-white transition-colors">联系反馈</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">联系我们</h3>
            <ul className="space-y-2.5 text-sm text-secondary-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                hello@online-platform.cn
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                400-800-2026
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                服务范围：全国 · 线上为主
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-mail-send-line"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">© 2026 在线 · 多元化在线服务平台 · 本站内容为前端演示数据</p>
          <div className="flex items-center gap-4 text-xs text-secondary-400">
            <span className="hover:text-white transition-colors cursor-pointer">服务条款</span>
            <span className="hover:text-white transition-colors cursor-pointer">隐私政策</span>
            <span className="hover:text-white transition-colors cursor-pointer">友情链接</span>
          </div>
        </div>
      </div>
    </footer>
  );
}